import { FC, memo } from 'react'
import sclasses from '../SetCourseClassDirectionModal/index.module.css'
import spclasses from '../SetCourseClassDirectionModal/purchase.module.css'
import cn from 'classnames'
import type { LeadProfileLead } from '../../../../LeadProfileModal.types'
import { InputNew } from '@UI/InputNew'
import {
  getLeadField,
  getLeadFieldValue,
} from '@pages/Admin/CRM/utils/leadFields'
import { useGetExtraPurchaseFields } from '@pages/Admin/PlatformSettings2/DirectorySettings/components/ExtraPurchaseFields/utils'

type LeadBoundUser = { name?: string; email?: string; phone?: string }

const UserFields: FC<{ lead: LeadProfileLead }> = memo(({ lead }) => {
  const { extraFields } = useGetExtraPurchaseFields()
  const leadUser: LeadBoundUser | null =
    lead.user && typeof lead.user === 'object'
      ? (lead.user as LeadBoundUser)
      : null
  const parentNameField = getLeadField(lead, 'PARENTNAME')
  const parentEmailField = getLeadField(lead, 'PARENTEMAIL')
  const parentPhoneField = getLeadField(lead, 'PARENTPHONE')

  return (
    <>
      <p className={sclasses.textDescription}>
        {leadUser
          ? 'У этого лида уже есть личный кабинет'
          : 'У этого лида пока нету личного кабинета, он будет создан при покупке'}
      </p>
      {!lead.user_id && extraFields.includes('studentName') && (
        <div className={sclasses.inputWithLabel}>
          {/* @ts-ignore */}
          <InputNew
            disabled={true}
            className={cn(spclasses.input, spclasses.disabledInput)}
            title="ФИО учащегося"
            value={leadUser?.name || getLeadFieldValue(lead, 'NAME')}
          />
        </div>
      )}
      {!lead.user_id && extraFields.includes('studentEmail') && (
        <div className={sclasses.inputWithLabel}>
          {/* @ts-ignore */}
          <InputNew
            disabled={true}
            className={cn(spclasses.input, spclasses.disabledInput)}
            title="E-mail учащегося"
            value={leadUser?.email || getLeadFieldValue(lead, 'EMAIL')}
          />
        </div>
      )}
      {!lead.user_id && extraFields.includes('studentPhone') && (
        <div className={sclasses.inputWithLabel}>
          {/* @ts-ignore */}
          <InputNew
            disabled={true}
            className={cn(spclasses.input, spclasses.disabledInput)}
            title="Номер телефона учащегося"
            value={leadUser?.phone || getLeadFieldValue(lead, 'PHONE')}
          />
        </div>
      )}
      {extraFields.includes('parentName') && parentNameField?.is_active && (
        <div className={sclasses.inputWithLabel}>
          {/* @ts-ignore */}
          <InputNew
            disabled={true}
            className={cn(spclasses.input, spclasses.disabledInput)}
            title="ФИО родителя"
            value={parentNameField?.value || ''}
          />
        </div>
      )}
      {extraFields.includes('parentEmail') && parentEmailField?.is_active && (
        <div className={sclasses.inputWithLabel}>
          {/* @ts-ignore */}
          <InputNew
            disabled={true}
            className={cn(spclasses.input, spclasses.disabledInput)}
            title="E-mail родителя"
            value={parentEmailField?.value || ''}
          />
        </div>
      )}
      {extraFields.includes('parentPhone') && parentPhoneField?.is_active && (
        <div className={sclasses.inputWithLabel}>
          {/* @ts-ignore */}
          <InputNew
            disabled={true}
            className={cn(spclasses.input, spclasses.disabledInput)}
            title="Номер телефона родителя"
            value={parentPhoneField?.value || ''}
          />
        </div>
      )}

      {(!lead.user_id ||
        extraFields.includes('parentName') ||
        extraFields.includes('parentEmail') ||
        extraFields.includes('parentPhone')) && (
        <p className={sclasses.textSmallDescription}>
          * вы можете обновить эту информацию в карточке лида
        </p>
      )}
    </>
  )
})

export default UserFields
